import { render, staticRenderFns } from "./ReportCustomersBalancePage.vue?vue&type=template&id=4fe6437b&scoped=true"
import script from "./ReportCustomersBalancePage.vue?vue&type=script&lang=js"
export * from "./ReportCustomersBalancePage.vue?vue&type=script&lang=js"
import style0 from "./ReportCustomersBalancePage.vue?vue&type=style&index=0&id=4fe6437b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe6437b",
  null
  
)

export default component.exports